import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamMembershipCreate } from '@api/sdk.gen';

import { userQueryKeys } from '@/portainer/users/queries/queryKeys';
import { UserId } from '@/portainer/users/types';
import { withError, withInvalidate } from '@/react-tools/react-query';
import { teamQueryKeys } from '@/react/portainer/users/teams/queries/query-keys';
import { TeamId, TeamRole } from '@/react/portainer/users/teams/types';

export function useAddUserToTeamMutation(userId: UserId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ teamId, role }: { teamId: TeamId; role: TeamRole }) =>
      addUserToTeam(userId, teamId, role),
    ...withError('Unable to add the user to the team'),
    ...withInvalidate(queryClient, [
      teamQueryKeys.base(),
      userQueryKeys.memberships(userId),
    ]),
  });
}

async function addUserToTeam(userId: UserId, teamId: TeamId, role: TeamRole) {
  await teamMembershipCreate({
    body: { UserID: userId, TeamID: teamId, Role: role },
  });
}
